var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack372({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.44,3.94A1.37,1.37,0,0,0,8,3.88H7.38V6.5H8a1,1,0,0,0,.55-.12A.77.77,0,0,0,8.82,6,2.54,2.54,0,0,0,9,5.17a2.07,2.07,0,0,0-.14-.83A.81.81,0,0,0,8.44,3.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,0,3.89,7.74h8.22Zm.72,6.7a1.32,1.32,0,0,1-.7.17H7V3.47H8a1.82,1.82,0,0,1,.54.06,1,1,0,0,1,.43.3,1.67,1.67,0,0,1,.28.55,2.71,2.71,0,0,1,.1.79,2.44,2.44,0,0,1-.17,1A1.23,1.23,0,0,1,8.72,6.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.89,8.26,8,16l4.11-7.7Zm4.84,4.06V10.7H7.26v1.62H6.89V8.89h.37V10.3H8.73V8.89H9.1v3.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack372);
export default __webpack_public_path__ + "static/media/Symbol_pack_372.740607634073d4dbaf55e89ea8ee7537.svg";
export { ForwardRef as ReactComponent };